import React, { useState, useRef, useEffect } from 'react';
import { Softorithm_White_Logo } from '../images';
import './sass/whatsapp.scss';

const WhatsApp = ({
  brandName = 'SoftoRithm Technologies',
  status = 'Replies within 1 hour',
  messageText = 'How can we help?',
  number = '923338469166',
  BgImage = 'https://res.cloudinary.com/dlysixl4e/image/upload/v1696925108/whatsappBg_ubnm7c.jpg',
  logo = Softorithm_White_Logo,
}) => {
  const dropdownRef = useRef(null);
  const [handelWhatsApp, setHandelWhatsApp] = useState(false);
  const [whatsAppSnip, setwhatsAppSnip] = useState(false);
  const [message, setMessage] = useState('');
  const Url = `https://wa.me/${number}?text=${encodeURIComponent(message || messageText)}`;

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setHandelWhatsApp(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setwhatsAppSnip(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  function handelSubmit() {
    if (!message) return;
    window.open(Url, '_blank');
    setMessage('');
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handelSubmit();
    }
  };

  if (!whatsAppSnip) return null;

  return (
    <div className="whatsapp-wrapper" ref={dropdownRef}>
      {handelWhatsApp && (
        <div className="whatsapp-chat" style={{ backgroundImage: `url(${BgImage})` }}>
          <div className="whatsapp-head">
            <div className="dp">
              <div className="image">
                <img src={logo} alt="logo" />
              </div>
            </div>
            <div className="text">
              <h1>{brandName}</h1>
              <p>{status}</p>
            </div>
            <div className="cross" onClick={() => setHandelWhatsApp(false)}>
              <i className="ri-close-line"></i>
            </div>
          </div>
          <div className="whatsapp-body">
            <div className="message-bubble">
              <h4>{brandName}</h4>
              <p>{messageText}</p>
            </div>
          </div>
          <div className="whatsapp-message">
            <input
              placeholder="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={handleKeyPress}
              maxLength={200}
            />
            <div className="icon" id="whatsapp-button" onClick={handelSubmit}>
              <i className="ri-send-plane-fill"></i>
            </div>
          </div>
        </div>
      )}
      <div className="whatsapp-icon">
        <div
          className="pulsating-circle"
          onClick={() => {
            setHandelWhatsApp(!handelWhatsApp);
          }}
        >
          <i className="ri-whatsapp-fill"></i>
        </div>
      </div>
    </div>
  );
};

export default WhatsApp;
